module.exports = __webpack_public_path__ + "img/RINCON_DEL_MEZQUITE.48f190a2.jpg";